import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationService } from 'src/app/shared/services/application.service';

@Component({
  selector: 'app-mail-modal',
  templateUrl: './mail-modal.component.html',
  styleUrls: ['./mail-modal.component.css']
})
export class MailModalComponent implements OnInit {
  @Input() years: string[];
  selectedYear: string;

  constructor(
    private modalService: NgbModal,
    private applicationService: ApplicationService
  ) {}

  ngOnInit(): void {}

  onOpenModal(content) {
    this.modalService.open(content, { centered: true }).result.then(result => {
      if (result == 'skicka') {
        console.log(this.selectedYear);
        this.applicationService.mailDeclinedApplications(this.selectedYear);
      }
    });
  }
}
